import React from 'react';
import ReactDOM from 'react-dom';
import { FocusStyleManager } from "@blueprintjs/core";

import * as Sentry from '@sentry/browser';

import './css/global.css';
import App from './App';
//import * as serviceWorker from './serviceWorker';
 
Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_URL,
  environment: process.env.NODE_ENV
});

FocusStyleManager.onlyShowFocusOnTabs();

ReactDOM.render(
  <React.Fragment>
    <App />
  </React.Fragment>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();
